"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormatSupplies = void 0;
var react_1 = __importDefault(require("react"));
var __1 = require("..");
var mappings_1 = require("../../../../shared/api/mappings");
var utils_1 = require("../../utils");
var reads_config_1 = require("../../utils/reads-config");
var SupplyMessages_1 = require("./SupplyMessages");
var useFormatSupplies = function (_a) {
    var supply = _a.supply, supplyIndex = _a.supplyIndex;
    var registers = supply.registers, meterNumOfDigits = supply.meterNumOfDigits, readings = supply.readings, meterStatus = supply.meterStatus;
    var latestImportantReading = (0, utils_1.getLatestImportantReading)(readings);
    var actions = (0, utils_1.getCTAs)(supply.states);
    var showReads = !(0, reads_config_1.readsConfig)('industryReadsRequired') ||
        supply.states.hasIndustryOpeningRead;
    var getMeterReadingSource = function (readingType) {
        var newReadType = (0, mappings_1.legacyToNew)(readingType);
        if (!newReadType) {
            return undefined;
        }
        var source = newReadType.source, type = newReadType.type;
        if (source === 'INDUSTRY') {
            if (type === 'ACTUAL') {
                return 'IndustryActual';
            }
            else if (type === 'ESTIMATE') {
                return 'IndustryEstimate';
            }
        }
        else if (source === 'MANUAL_READ_AGENT' ||
            source === 'MANUAL_READ_CUSTOMER') {
            return 'CustomerAgentActual';
        }
        return undefined;
    };
    var mapRegisters = function (registers) {
        return registers.map(function (_a) {
            var _b;
            var registerId = _a.registerId, timeOfUseLabel = _a.timeOfUseLabel;
            return ({
                timeOfUseLabel: supply.states.showSimplifiedLabels
                    ? null
                    : timeOfUseLabel,
                formattedReadingDate: (_b = latestImportantReading === null || latestImportantReading === void 0 ? void 0 : latestImportantReading.formattedReadingDate) !== null && _b !== void 0 ? _b : undefined,
                registerId: registerId,
                meterReading: latestImportantReading
                    ? (0, utils_1.getReadValue)({
                        reading: latestImportantReading,
                        timeOfUseLabel: timeOfUseLabel || undefined,
                        meterNumOfDigits: meterNumOfDigits,
                        registerId: registerId,
                    })
                    : undefined,
                source: latestImportantReading
                    ? getMeterReadingSource(latestImportantReading.readingType)
                    : undefined,
            });
        });
    };
    return {
        msn: supply.msn,
        fuel: supply.fuel,
        registers: showReads
            ? mapRegisters(registers).filter(function (register) { return register.meterReading; })
            : [],
        children: (react_1.default.createElement(SupplyMessages_1.SupplyMessages, { supplyStates: supply.states, status: meterStatus, fuel: supply.fuel })),
        footer: actions.length > 0 ? (react_1.default.createElement(__1.CallToActionSection, { actions: actions, fuelType: supply.fuel, isSmart: supply.states.isSmart, supplyIndex: supplyIndex })) : undefined,
    };
};
exports.useFormatSupplies = useFormatSupplies;
